import React from 'react'
import TextInput from './inputfields/TextInput';
import NumberInput from './inputfields/NumberInput';
import RadioButtons from './inputfields/RadioButtons';
import CheckBoxInput from './inputfields/CheckBoxInput';

function FormikControl({ type, ...rest }) {

    const {field} = rest;

    switch (type) {
        case "text":
            return <TextInput {...rest}/>;
        case "number":
            return <NumberInput {...rest}/>;
        case "radio":
            return <RadioButtons radioField={field} {...rest}/>;
        case "checkbox":
            return <CheckBoxInput radioField={field} {...rest}/>;
        default:
            return null;
    }
}

export default FormikControl